import react, { useState } from "react";
import VisitChart from "./VisitsChart";
import { Link, Outlet } from "react-router-dom";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
import EventFormModal from "../../../Events/form/EventFormModal";

const SingleSpot = ({
  data,
  showUsersAccess,
  showPaymentInfo,
  handlerSponsorVenue,
}) => {
  const [eventModal, setEventModal] = useState({
    show: false,
    id: null,
  });

  const renderTooltip = (props) => (
    <Tooltip id="button-tooltip" {...props}>
      Número de interacções nos últimos 30 dias
    </Tooltip>
  );

  const VenueStatus = () => {
    if (data.status === 'PENDING') {
      return (
        <div className="box-aprove-pending">
          Pendente de Aprovação
        </div>
      )
    }
    return null;
  }

  return (
    <div className="col-12 col-md-6 mb-4">
      <EventFormModal
        show={eventModal.show}
        id={data.id}
        handleModalShow={() => setEventModal({ show: true, id: data.id })}
        handleModalhide={() => setEventModal({ show: false, id: null })}
      />
      <div className="box-venue">
        <VenueStatus />

        <div className="d-flex justify-content-between align-items-center mb-3">
          <h3 className="title mb-0">{data.name}</h3>
          <Link
            to={`/my/nightspots/update/${data.id}`}
            className="btn-edit-spot"
          >
            <i className="fa-regular fa-pen-to-square"></i>
          </Link>

        </div>

        <div className="divisor"></div>

        <div className="venue-stats-container">
          <div className="venue-stat-item">
            <div className="stats-title">Eventos</div>
            <div className="stats-value">{data.numEventScheduled}</div>
          </div>
          <div className="venue-stat-item">
            <div className="stats-title">Promotores</div>
            <div className="stats-value">{data.numPromoters}</div>
          </div>
          <div className="venue-stat-item">
            <div className="stats-title">
              <OverlayTrigger
                placement="top"
                delay={{ show: 250, hide: 400 }}
                overlay={renderTooltip}
              >
                <span>Interações</span>
              </OverlayTrigger>
            </div>
            <div className="stats-value">{data.interaction}</div>
          </div>
        </div>

        <div className="row g-2 mb-2 quick-actions">
          <div className="col-6">
            <div
              className="btn-action btn-action-primary"
              onClick={() => setEventModal({ show: true, id: data.id })}
            >
              <i className="fa-solid fa-calendar-plus"></i>
              <span>Evento</span>
            </div>
          </div>
          <div className="col-6">
            <div
              className="btn-action btn-action-secondary"
              onClick={() => showUsersAccess(data.id)}
            >
              <i className="fa-solid fa-gears"></i>
              <span>Utilizadores</span>
            </div>
          </div>
        </div>

        <div className="row g-2 quick-actions mb-2">
          <div className="col-4">
            <Link to={`/my/nightspots/${data.id}/contacts`} className="btn-action btn-action-info">
              <i className="fa-solid fa-phone"></i>
              <span>Contactos</span>
            </Link>
          </div>
          <div className="col-4">
            <Link to={`/my/nightspots/${data.id}/tables`} className="btn-action btn-action-warning">
              <i className="fa-solid fa-crown"></i>
              <span>Mesas</span>
            </Link>
          </div>
          <div className="col-4">
            <Link to={`/my/nightspots/${data.id}/payments/details`} className="btn-action btn-action-success">
              <i className="fa-solid fa-eur"></i>
              <span>Financeiro</span>
            </Link>
          </div>
        </div>

        <div className="row g-2 quick-actions">
          <div className="col-12">
            <Link to={`/my/nightspots/${data.id}/wallet`} className="btn-action btn-action-primary d-flex justify-content-between align-items-center px-4">
              <div className="d-flex align-items-center gap-2">
                <i className="fa-solid fa-wallet"></i>
                <span>Wallet</span>
              </div>
              <span className="badge bg-white text-primary">
                {data.credits || 0} Créditos
              </span>
            </Link>
          </div>
        </div>


      </div>
    </div>
  );
};

export default SingleSpot;
